const KEY = "tme_consent";
let loaded = false;

export const getConsent = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};

function inject(src) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

export function loadTrackers(t = {}) {
  if (loaded || getConsent() !== "granted") return;
  loaded = true;
  if (t.ga4_id) {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", t.ga4_id);
    inject(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(t.ga4_id)}`);
  }
  if (t.meta_pixel_id && !window.fbq) {
    const f = function fbq() { f.callMethod ? f.callMethod.apply(f, arguments) : f.queue.push(arguments); };
    f.push = f; f.loaded = true; f.version = "2.0"; f.queue = [];
    window.fbq = f; window._fbq = f;
    inject("https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", t.meta_pixel_id);
    window.fbq("track", "PageView");
  }
  if (t.tiktok_pixel_id && !window.ttq) {
    const q = [];
    const ttq = { _q: q };
    ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"].forEach((m) => {
      ttq[m] = (...a) => q.push([m, ...a]);
    });
    window.TiktokAnalyticsObject = "ttq";
    window.ttq = ttq;
    ttq._i = { [t.tiktok_pixel_id]: [] };
    ttq._t = { [t.tiktok_pixel_id]: +new Date() };
    ttq._o = { [t.tiktok_pixel_id]: {} };
    inject(`https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${encodeURIComponent(t.tiktok_pixel_id)}&lib=ttq`);
    ttq.page();
  }
}

export function setConsent(v, tracking) {
  try { localStorage.setItem(KEY, v); } catch { /* storage blocked */ }
  if (v === "granted") loadTrackers(tracking);
}

export function track(name, params = {}) {
  if (getConsent() !== "granted") return;
  window.gtag?.("event", name, params);
}

export function trackLead(params = {}) {
  if (getConsent() !== "granted") return;
  window.fbq?.("track", "Lead", params);
  window.ttq?.track?.("Lead", params);
}
